import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';

import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';
import {QuestionTypeFactoryService} from 'shared/questions/services/question-type-factory.service';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {ModalConfirmationModule} from '../../../shared/modals/modal-confirmation/modal-confirmation.module';
import {QuestionsOverviewRoutingModule} from './questions-overview-routing.module';
import {QuestionsOverviewComponent} from './questions-overview.component';
import {QuestionsOverviewHttpRepository} from './repositories/questions-overview.repository.http';
import {QuestionsOverviewService} from './services/questions-overview.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    QuestionsOverviewRoutingModule,
    ModalConfirmationModule,
    SearchBarModule,
  ],
  declarations: [
    QuestionsOverviewComponent,
  ],
  providers: [
    QuestionTypeFactoryService,
    QuestionsOverviewService,
    {
      provide: 'IQuestionsOverviewRepository',
      useClass: QuestionsOverviewHttpRepository,
    },
  ],
})
export class QuestionsOverviewModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-overview/questions-overview.module.ts